import { useState, useRef } from 'react';
import ImageUploadInput from 'components/ImageUploadInput';
import CriticalitySlider from 'components/CriticalitySlider';
import { LoadingIcon, CheckIcon } from 'components/Icons';

import { useMutation, useQuery } from '@apollo/client';
import { handleImageUpload } from 'components/Helpers';
import { MY_BUG_REPORTS_QUERY, CREATE_BUG_REPORT_MUTATION } from 'graphql/APICalls';
import BugReportList from 'components/BugReportList';

import 'styles/BugReportPage.css';

export default function BugReportPage() {

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [submissionStatus, setSubmissionStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const imageUploadInputRef = useRef(null);
  const sliderRef = useRef(null);

  const [createBugReport] = useMutation(CREATE_BUG_REPORT_MUTATION);
  const { data: bugReportsData } = useQuery(MY_BUG_REPORTS_QUERY);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('loading');
    setErrorMessage('');

    if (!title.trim()) {
      setErrorMessage('Please enter a title');
      setSubmissionStatus('idle');
      return;
    }

    try {
      const createdImageIds = await Promise.all(images.map(image => handleImageUpload(image)));

      await createBugReport({
      variables: {
          title,
          description,
          images: createdImageIds,
          criticality: sliderRef.current.value
      },
      refetchQueries: [
          { query: MY_BUG_REPORTS_QUERY }
      ]
      });
      
      setSubmissionStatus('success');
      setTimeout(handleReset, 2000);
    
    } catch (error) {
      setErrorMessage(error.message);
      setSubmissionStatus('idle');
    }
  };

  const handleReset = () => {
    setSubmissionStatus('idle');
    setTitle('');
    setDescription('');
    imageUploadInputRef.current.clear();
    sliderRef.current.reset();
  };

  return (
    <div className="auto-scrollbar">
    <div className="centerer activity-page-overlay">
      <div className="centered bug-report-container">
        
        <div className="card">
          <h2>Found a bug?</h2>
          <p>TagAlong is a work in progress and we'd love your feedback!</p>
          <p>You can use this page to report bugs, suggest features, or just give us a general idea of what you think.</p>
          <p>Once you've made a report, you'll see it below and we'll send you a notification when we've fixed it ✌️❤️</p>
        </div>

        <div className="card">
          <div className={`overlay ${submissionStatus}`}>
            <LoadingIcon id="loading-icon"/>
            <CheckIcon id="check-icon"/>
          </div>
          <form className="form-1" style={{color: 'black'}} onSubmit={handleSubmit}>
            <label>Title</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
            <label>Description</label>
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
            <label>Images</label>
            <ImageUploadInput ref={imageUploadInputRef} onChange={files => setImages(files)} />
            <label>Importance</label>
            <CriticalitySlider ref={sliderRef} />
            <div className="error-message" style={{display: errorMessage.length ? 'block' : 'none'}}>{errorMessage}</div>
            <button type="submit">Send</button>
          </form>
        </div>

        <div className="card">
          <h3>Your reports</h3>
          <BugReportList bugReports={bugReportsData?.me?.bugReports} noReportsMessage="No reports yet. You can submit one above!" />
        </div>
        
      </div>
    </div>
    </div>
  )
}